var _style, _path, _g, _g2, _g3, _defs, _g4, _g5, _g6, _g7, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLgbtqiaFinal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D3E7F1;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000137097400452935493520000011391036430896439216_);}\n\t.st3{fill:url(#SVGID_00000174571413054294141200000002085839042398823809_);}\n\t.st4{fill:url(#SVGID_00000156565583742478522480000000902796281281325725_);}\n\t.st5{fill:#E40014;}\n\t.st6{fill:#FF8C00;}\n\t.st7{fill:#F5F700;}\n\t.st8{fill:#74C809;}\n\t.st9{fill:#66C1ED;}\n\t.st10{fill:#008FA3;}\n\t.st11{fill:#46408A;}\n\t.st12{fill:#CB7F15;}\n\t.st13{fill:#FFB700;}\n\t.st14{fill:#FEC901;}\n\t.st15{fill:#985F10;}\n\t.st16{opacity:0.6;fill:#46408A;}\n\t.st17{opacity:0.6;fill:#66C1ED;}\n\t.st18{opacity:0.6;fill:#74C809;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M935.6,300.3c23.6,96.6,11.6,163.4-32.2,213.9c-30,34.5-30.1,79.2-0.4,113.9c28.1,32.8,44.6,71.9,45,113.8 c1.1,118.2-131.7,231.5-288.9,231.1c-62.8-0.2-191.5-66.9-316.9-69.9C204,899.7,5.5,762.6,21.2,633.6 c10.1-83.2,77-139.5,121.4-173.1c101.1-76.6,30.7-189,30.3-189.8C85.2,44.3,338.1,7.6,545.5,17.4 C781.2,28.4,912.2,204.5,935.6,300.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.3,590.6c-2.4-6-6.6-14.8-14.2-23.6c-4-4.6-15.4-16.9-34.2-23.6c-28.5-10.2-53.8-0.4-60.2,2.4 c-1.8-5.1-4.9-12.5-10.6-20.1c-13.3-17.7-38.8-34.2-69.7-30.7c-27.2,3.1-50.7,20.7-61.4,46c-3.1-1.2-8-2.8-14.2-3.5 c-27.4-3.4-48.8,13.2-53.1,16.5c-3.7,2.9-8.9,7.5-14.2,14.2c-2.9-1.6-7.3-3.6-13-4.7c-18.5-3.5-33.1,6.6-35.4,8.3 c-10.1,7.3-14.7,16.7-16.5,21.3L515.3,590.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M816.9,767.7c0-37-13.1-50.9-20.7-59.7c-4-4.6-15.4-16.9-34.2-23.6c-28.5-10.2-53.8-0.4-60.2,2.4 c-1.8-5.1-4.9-12.5-10.6-20.1c-13.3-17.7-38.8-34.2-69.7-30.7c-27.2,3.1-50.7,20.7-61.4,46c-3.1-1.2-8-2.8-14.2-3.5 c-27.4-3.4-48.8,13.2-53.1,16.5c-3.7,2.9-8.9,7.5-14.2,14.2c-2.9-1.6-7.3-3.6-13-4.7c-18.5-3.5-33.1,6.6-35.4,8.3 c-10.1,7.3-14.7,16.7-10,57.3L816.9,767.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.5,423.1c2.6-6.7,7.4-16.5,15.8-26.4c4.4-5.2,17.2-18.9,38.2-26.4c31.9-11.4,60-0.4,67.3,2.6 c2-5.8,5.5-14,11.9-22.4c14.9-19.7,43.3-38.2,77.8-34.3c30.4,3.4,56.6,23.1,68.6,51.4c3.5-1.3,9-3.1,15.8-4 c30.6-3.8,54.5,14.7,59.3,18.5c4.2,3.2,10,8.3,15.8,15.8c3.2-1.8,8.2-4.1,14.5-5.3c20.7-3.9,37,7.4,39.6,9.2 c11.3,8.1,16.4,18.6,18.5,23.7L357.5,423.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M935.7,307.4c23.6,95.1,11.6,160.9-32.1,210.6c-29.9,34-30,78-0.4,112.1c28.1,32.3,44.5,70.7,44.9,112 c1.1,116.4-118.3,254.4-295.8,234.4c-62.3-7-183.6-72.8-308.8-75.7C205.5,897.5-0.2,765.1,10.9,605 c3.5-50.3,15.6-108.1,60.9-136.3c79.9-49.8,48.9-143.6,48.8-144.5C81.7,24.1,310.9,28.8,546.3,28.8S912.3,213.1,935.7,307.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093868468690452973160000011977414963524875137_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093868468690452973160000011977414963524875137_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.2
    },
    width: 1029,
    height: 665,
    xlinkHref: "16B6B03ED53E1B8E.png",
    transform: "matrix(1 0 0 1 -44 341)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183240637600951054830000007339171238777752470_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.5962,
    y1: 1089.248,
    x2: -144.3849,
    y2: -473.8146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183240637600951054830000007339171238777752470_)"
    },
    d: "M346.8,385.2 c-145.6,15.2-83.9,66.8,109.5,112.7C614.7,535.5,317,584.6,317,584.6S79.7,615.2,118.6,707.2s220.7,112.5,304.9,157.9 c123.5,66.5-459,118-459,118h968.3c0,0,157.8-205.6-250.3-255.7c-408.1-50.2-113.3-112.1-113.3-112.1s247.7-58.4,77.2-117.4 c-186.4-64.5-314.7-65.6-203.3-108.2s-42.4-40.5-42.4-40.5"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101781639514883845570000003988581826595200413_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.8601,
    y1: 318.474,
    x2: 451.0997,
    y2: 24.6123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A26B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B6802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#E3AB2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#FFF6AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    style: {
      stopColor: "#DDA62C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#B0742A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#9C5B27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F2BA2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101781639514883845570000003988581826595200413_)"
    },
    d: "M539.9,190c-0.7,1.8-1.5,3.7-2.5,5.6 c-7,14-21.2,32.7-39,53.3c-14.7,17.1-31.9,35.4-49.5,53.3c-18.4,18.8-37.2,37.3-54,53.3c-32.4,31-57.2,53.3-57.2,53.3 s-22.3-22.2-51.7-53.3c-15.1-16-32.2-34.4-49-53.3c-15.8-17.8-31.5-36.1-45.3-53.3c-15.9-19.9-29.3-38.5-37.6-53.3 c-3.2-5.8-5.7-11.1-7.2-15.6c-4.1-12.5-5.8-25.2-5.4-37.7c0.6-19,6.1-37.4,15.7-53.3c13.1-21.9,33.9-39.3,60.1-47.8 c11.4-3.7,22.9-5.5,34.3-5.5c38.3,0,74.4,20.1,94.3,53.3c0,0,0,0,0,0c0,0,0,0,0,0c28-41.7,82-60,130.9-41.2 c21.9,8.4,39.6,23.1,51.8,41.2c10.6,15.8,17.1,34.2,18.5,53.3C548.1,158.1,545.9,174.3,539.9,190z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M332.1,95H154.8c12.4-20.5,31.9-36.9,56.4-45c10.7-3.5,21.5-5.2,32.2-5.2C279.4,44.8,313.3,63.8,332.1,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M503.8,95H332.1c26.3-39.2,77.1-56.4,123-38.8C475.8,64.1,492.4,77.9,503.8,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M521.2,145.1H140c0.6-17.9,5.8-35.1,14.8-50.1h349.1C513.8,109.8,519.8,127.1,521.2,145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M514.6,190c-0.6,1.7-1.4,3.4-2.4,5.3H151.8c-3-5.5-5.3-10.4-6.7-14.7c-3.9-11.8-5.5-23.7-5.1-35.4h381.2 C522.3,159.9,520.2,175.2,514.6,190z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M512.2,195.2c-6.5,13.1-19.9,30.8-36.7,50.1H187.1c-15-18.7-27.6-36.2-35.3-50.1H512.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M475.5,245.4c-13.9,16-30,33.3-46.5,50.1H229.7c-14.9-16.7-29.6-33.9-42.6-50.1H475.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M429,295.5c-17.3,17.7-35,35-50.8,50.1H275.8c-14.2-15.1-30.2-32.3-46.1-50.1H429z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M378.2,345.7c-30.4,29.1-53.8,50.1-53.8,50.1s-21-20.9-48.6-50.1H378.2z"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "YellowUmbrella_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M786.3,669.5c-20.3,0-36.7-16.5-36.7-36.7c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3 c0,13.3,10.8,24.1,24.1,24.1c13.3,0,24.1-10.8,24.1-24.1v-29.3c0-3.5,2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3v29.3 C823,653,806.6,669.5,786.3,669.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M816.7,356.8c41.6,0,75.3,94.9,75.3,136.5c0,0,18.7-19.5,52.9-19.5c24.6,0,32.2,9.7,32.2,9.7 S941.8,356.8,816.7,356.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M816.7,356.8c-125.1,0-160.5,126.7-160.5,126.7s7.7-9.7,32.2-9.7c34.2,0,52.9,19.5,52.9,19.5 C741.5,451.7,775.2,356.8,816.7,356.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M816.7,356.8c-41.6,0-75.3,94.9-75.3,136.5c0,0,21.6-14.7,75.3-14.7s75.3,14.7,75.3,14.7 C892,451.7,858.3,356.8,816.7,356.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M821.2,356.8v-15.1c0-2.5-2-4.5-4.5-4.5s-4.5,2-4.5,4.5v15.1c1.5,0,3-0.1,4.5-0.1S819.8,356.8,821.2,356.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M812.2,478.6V599c1.1-1.2,2.7-1.9,4.5-1.9s3.4,0.7,4.5,1.9V478.6c-1.5,0-3,0-4.5,0S813.7,478.5,812.2,478.6z "
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "YellowUmbrella_00000116210194326472643270000000346610193320645043_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M597.1,409.4c-8.7,0-15.8-7.1-15.8-15.8c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7 c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4V381c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7v12.6 C612.9,402.3,605.8,409.4,597.1,409.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M610.2,274.8c17.9,0,32.4,40.8,32.4,58.7c0,0,8.1-8.4,22.8-8.4c10.6,0,13.9,4.2,13.9,4.2 S664,274.8,610.2,274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M610.2,274.8c-53.8,0-69,54.5-69,54.5s3.3-4.2,13.9-4.2c14.7,0,22.8,8.4,22.8,8.4 C577.8,315.7,592.3,274.8,610.2,274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M610.2,274.8c17.9,0,32.4,40.8,32.4,58.7c0,0,8.1-8.4,22.8-8.4c10.6,0,13.9,4.2,13.9,4.2 S664,274.8,610.2,274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M610.2,274.8c-53.8,0-69,54.5-69,54.5s3.3-4.2,13.9-4.2c14.7,0,22.8,8.4,22.8,8.4 C577.8,315.7,592.3,274.8,610.2,274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M610.2,274.8c-17.9,0-32.4,40.8-32.4,58.7c0,0,9.3-6.3,32.4-6.3s32.4,6.3,32.4,6.3 C642.6,315.7,628.1,274.8,610.2,274.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M612.2,274.9v-6.5c0-1.1-0.9-1.9-1.9-1.9s-1.9,0.9-1.9,1.9v6.5c0.6,0,1.3,0,1.9,0S611.5,274.9,612.2,274.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M608.3,327.2v51.8c0.5-0.5,1.2-0.8,1.9-0.8s1.4,0.3,1.9,0.8v-51.8c-0.6,0-1.3,0-1.9,0 S608.9,327.2,608.3,327.2z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "YellowUmbrella_00000094584245897395689830000015406361303193290886_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M670,258.1c-10.4,0-18.8-8.4-18.8-18.8c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2 c0,6.8,5.5,12.3,12.3,12.3c6.8,0,12.3-5.5,12.3-12.3v-15c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2v15 C688.8,249.6,680.4,258.1,670,258.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M685.6,98.1c21.3,0,38.5,48.5,38.5,69.8c0,0,9.6-10,27.1-10c12.6,0,16.5,5,16.5,5S749.6,98.1,685.6,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M685.6,98.1c-64,0-82.1,64.8-82.1,64.8s3.9-5,16.5-5c17.5,0,27.1,10,27.1,10 C647.1,146.6,664.3,98.1,685.6,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M685.6,98.1c21.3,0,38.5,48.5,38.5,69.8c0,0,9.6-10,27.1-10c12.6,0,16.5,5,16.5,5S749.6,98.1,685.6,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M685.6,98.1c-64,0-82.1,64.8-82.1,64.8s3.9-5,16.5-5c17.5,0,27.1,10,27.1,10 C647.1,146.6,664.3,98.1,685.6,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M685.6,98.1c-21.3,0-38.5,48.5-38.5,69.8c0,0,11-7.5,38.5-7.5s38.5,7.5,38.5,7.5 C724.1,146.6,706.8,98.1,685.6,98.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M687.9,98.1v-7.7c0-1.3-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3v7.7c0.8,0,1.5,0,2.3,0 C686.4,98.1,687.1,98.1,687.9,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M683.3,160.4V222c0.6-0.6,1.4-1,2.3-1c0.9,0,1.7,0.4,2.3,1v-61.6c-0.8,0-1.5,0-2.3,0 C684.8,160.4,684,160.4,683.3,160.4z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "YellowUmbrella_00000011730781199315717930000009418278384462671031_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M743.3,312.2c-3.6,0-6.6-3-6.6-6.6c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1c0,2.4,1.9,4.3,4.3,4.3 c2.4,0,4.3-1.9,4.3-4.3v-5.3c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v5.3C749.9,309.2,746.9,312.2,743.3,312.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M748.7,255.9c7.5,0,13.5,17.1,13.5,24.5c0,0,3.4-3.5,9.5-3.5c4.4,0,5.8,1.8,5.8,1.8S771.2,255.9,748.7,255.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M748.7,255.9c-22.5,0-28.9,22.8-28.9,22.8s1.4-1.8,5.8-1.8c6.1,0,9.5,3.5,9.5,3.5 C735.2,273,741.3,255.9,748.7,255.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M748.7,255.9c7.5,0,13.5,17.1,13.5,24.5c0,0,3.4-3.5,9.5-3.5c4.4,0,5.8,1.8,5.8,1.8S771.2,255.9,748.7,255.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M748.7,255.9c-22.5,0-28.9,22.8-28.9,22.8s1.4-1.8,5.8-1.8c6.1,0,9.5,3.5,9.5,3.5 C735.2,273,741.3,255.9,748.7,255.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M748.7,255.9c-7.5,0-13.5,17.1-13.5,24.5c0,0,3.9-2.6,13.5-2.6s13.5,2.6,13.5,2.6 C762.3,273,756.2,255.9,748.7,255.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M749.6,255.9v-2.7c0-0.4-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v2.7c0.3,0,0.5,0,0.8,0S749.3,255.9,749.6,255.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M747.9,277.8v21.7c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3v-21.7c-0.3,0-0.5,0-0.8,0 S748.2,277.8,747.9,277.8z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "YellowUmbrella_00000166635158805869351130000000702295246465916333_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M125.9,726.8c-17,0-30.8-13.8-30.8-30.8c0-2.9,2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3c0,11.2,9.1,20.2,20.2,20.2 c11.2,0,20.2-9.1,20.2-20.2v-24.6c0-2.9,2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3V696C156.7,713,142.9,726.8,125.9,726.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.4,464.8c34.8,0,63.1,79.5,63.1,114.3c0,0,15.7-16.3,44.3-16.3c20.6,0,27,8.2,27,8.2 S256.2,464.8,151.4,464.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.4,464.8C46.7,464.8,17,570.9,17,570.9s6.4-8.2,27-8.2c28.6,0,44.3,16.3,44.3,16.3 C88.4,544.3,116.6,464.8,151.4,464.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M151.4,464.8c34.8,0,63.1,79.5,63.1,114.3c0,0,15.7-16.3,44.3-16.3c20.6,0,27,8.2,27,8.2 S256.2,464.8,151.4,464.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M151.4,464.8C46.7,464.8,17,570.9,17,570.9s6.4-8.2,27-8.2c28.6,0,44.3,16.3,44.3,16.3 C88.4,544.3,116.6,464.8,151.4,464.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.4,464.8c-34.8,0-63.1,79.5-63.1,114.3c0,0,18.1-12.3,63.1-12.3s63.1,12.3,63.1,12.3 C214.5,544.3,186.2,464.8,151.4,464.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M155.2,464.8v-12.6c0-2.1-1.7-3.8-3.8-3.8s-3.8,1.7-3.8,3.8v12.6c1.2,0,2.5-0.1,3.8-0.1 S153.9,464.8,155.2,464.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M147.7,566.8v100.9c1-1,2.3-1.6,3.8-1.6s2.8,0.6,3.8,1.6V566.8c-1.2,0-2.5,0-3.8,0 C150.1,566.8,148.9,566.8,147.7,566.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgbtqiaFinal);
export default __webpack_public_path__ + "static/media/LGBTQIA_final.c98565bbfc916066e5f0b04ecdf95d22.svg";
export { ForwardRef as ReactComponent };